module.exports = __webpack_public_path__ + "media/Fa.07462c16.wav";